module.exports = __webpack_public_path__ + "static/img/img_logo.d9ba3973.png";